import React from "react";
import PropTypes from "prop-types";
import AjaxTableDisplay from "../../../misc/AjaxTableDisplay";

const reportTableSampleDisplayProps = {
    // Passed In
    tableKey: PropTypes.number,
};

type ReportTableSampleDisplayProps = PropTypes.InferProps<typeof reportTableSampleDisplayProps>;

const ReportTableSampleDisplay: React.FC<ReportTableSampleDisplayProps> = ({
    tableKey,
}: ReportTableSampleDisplayProps) => {
    if (tableKey == null) {
        return null;
    }

    return (
        <AjaxTableDisplay
            countUrl={"/FlowItemReports/CountTable/" + tableKey}
            dataUrl={"/FlowItemReports/DataTable/" + tableKey}
            header={null}
            footer={"Note: The records shown are a sample of the table selected. Only 250 records are shown."}
            belowErrorMessage={null}
            showRecordCount
        />
    );
};

export default ReportTableSampleDisplay;
